module.exports = __webpack_public_path__ + "img/mercadopago.106e4d8c.jpg";